import { useQuery } from 'urql';
import { GetMagazinContentDocument } from '@packages/gql/generated/shopping/GetMagazinContentDocument';
import { useMemo } from 'react';
import { logger } from '@packages/shared/src/utils/logger/logger';

/* GraphQL */ `
  query GetMagazinContent($tags: [String!]!, $limit: Int) {
    getMagazinContentMultipleTags(tags: $tags, limit: $limit) {
      id
      description
      headline
      taxonomy_terms
      path
      teaser_image {
        id
        url
        alt
        title
        width
        height
      }
    }
  }
`;

export const useRelatedContentGql = (tags: string[], limit?: number) => {
  const [{ data, error, fetching }] = useQuery({
    query: GetMagazinContentDocument,
    variables: { tags, limit },
    context: useMemo(() => ({ suspense: false }), []),
  });
  if (error) {
    logger.error(`Error fetching related content: ${error.message}`);
    return { error };
  }
  return { fetching, relatedContentData: data?.getMagazinContentMultipleTags || [] };
};
